import * as Yup from "yup";

export const TicketProcessingRulesConstants = {
  EDIT_OPTION: "Edit",
};

export const getTicketProcessingRuleList = ({
  uniqueUsers,
  uniqueSubmissions,
  failureLimit,
  maxSubmissionsByUser,
  notes,
}) => [
  ["Unique Users", uniqueUsers],
  ["Unique Ticket Submissions", uniqueSubmissions],
  ["Ticket failure limit", failureLimit],
  ["Maximum no of Submissions (Account)", maxSubmissionsByUser],
  ["Notes", notes],
];

export const TicketProcessingRulesValidation = Yup.object({
  uniqueUsers: Yup.number()
    .required("Required")
    .typeError("Please enter a valid number")
    .min(1, "value should be between 1 and 10.")
    .max(10, "value should be between 1 and 10."),
  uniqueTktSubmissions: Yup.number()
    .required("Required")
    .typeError("Please enter a valid number")
    .min(1, "value should be between 1 and 10.")
    .max(10, "value should be between 1 and 10.")
    .min(Yup.ref("uniqueUsers"), ({ min }) => `value must be at least equal to Unique Users count`),
  ticketFailureLimit: Yup.number()
    .required("Required")
    .typeError("Please enter a valid number")
    .min(1, "value should be between 1 and 10.")
    .max(10, "value should be between 1 and 10."),
  maxSubmissions: Yup.number()
    .required("Required")
    .typeError("Please enter a valid number")
    .min(1, "value should be between 1 and 10.")
    .max(10, "value should be between 1 and 10."),
  ruleNotes: Yup.string().required("Required"),
});

export const getDefaultValues = ({
  uniqueUsers,
  uniqueSubmissions,
  failureLimit,
  maxSubmissionsByUser,
  notes,
}) => {
  return {
    uniqueUsers: uniqueUsers,
    uniqueTktSubmissions: uniqueSubmissions,
    ticketFailureLimit: failureLimit,
    maxSubmissions: maxSubmissionsByUser,
    ruleNotes: notes,
  };
};
